import { makeFragmentData } from '@packages/gql/generated/shopping';
import {
  RatingIconsVerifiedFragmentFragmentDoc,
  type RatingIconsVerifiedFragmentFragment,
} from '@packages/gql/generated/shopping/graphql';

export const ratingIconsVerifiedDataMock: RatingIconsVerifiedFragmentFragment = {
  avgRating: 4.35,
  reviewCount: 35,
};

export function getRatingIconsVerifiedFragmentedData(data?: RatingIconsVerifiedFragmentFragment) {
  return makeFragmentData(
    data || ratingIconsVerifiedDataMock,
    RatingIconsVerifiedFragmentFragmentDoc,
  );
}
